// extracted by mini-css-extract-plugin
module.exports = {"icon":"FareCalendarLegendBadges-module__icon___bkIP4","loader":"FareCalendarLegendBadges-module__loader___7fBj0"};